import { render, staticRenderFns } from "./Payroll-Group.vue?vue&type=template&id=372b0ff8&"
import script from "./Payroll-Group.vue?vue&type=script&lang=js&"
export * from "./Payroll-Group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports